import type { OnboardingOnboardingAnswers } from '@customerio/hydra-ui-api';
import { isEmptyString } from '@/utils/string';

const hasListenTargets = (answers: OnboardingOnboardingAnswers | undefined): boolean =>
  (answers?.listen_targets?.length ?? 0) > 0;

/**
 * Whether the user finished the wizard's question set. Routing treats an
 * answered user as done with `/onboarding`, so this must not read true
 * mid-conversation: the wizard records `listen_targets` at its third question
 * of four, and counting that alone strands a user who leaves before the last
 * one with no route back into the chat.
 */
export function hasAnsweredOnboarding(answers: OnboardingOnboardingAnswers | undefined): boolean {
  return (
    !isEmptyString(answers?.goal) &&
    answers?.starting_point != null &&
    hasListenTargets(answers) &&
    answers.is_implementer != null
  );
}
